var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-md-block flex-row mb-2 mb-md-0"},[(_vm.label)?_c('div',{staticClass:"text-primary mr-3 mr-md-0"},[_vm._v(_vm._s(_vm.label)+":")]):_vm._e(),_c('div',{staticClass:"align-items-center"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }